import { requestHelpers } from '../../helpers';

const actions = {
    GET_NOTIFICATIONS_REQ: 'GET_NOTIFICATIONS_REQ',
    GET_NOTIFICATIONS_SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
    GET_NOTIFICATIONS_ERROR: 'GET_NOTIFICATIONS_ERROR',
    UPDATE_NOTIFICATION_REQ: 'UPDATE_NOTIFICATION_REQ',
    UPDATE_NOTIFICATION_SUCCESS: 'UPDATE_NOTIFICATION_SUCCESS',
    UPDATE_NOTIFICATION_ERROR: 'UPDATE_NOTIFICATION_ERROR'
}

function getNotifications(personId) {

    return ( dispatch ) => {

        dispatch( {
            type: actions.GET_NOTIFICATIONS_REQ,
            isFetching: true,
            isError: false
        } );

        requestHelpers
            .authenticatedGetRequest( `/people/${personId}/notifications` )
                .then( ( response ) => {
                    return dispatch( {
                        type: actions.GET_NOTIFICATIONS_SUCCESS,
                        notifications: response.data,
                        isFetching: false,
                        isError: false,
                    } );

                } )

                .catch( ( error ) => {
                    return dispatch( { 
                        type: actions.GET_NOTIFICATIONS_ERROR,
                        error: error,
                        isFecthing: false,
                        isError: true
                    } )
                } )
    }
}

function updateNotification( data  ) {
    return ( dispatch ) => {

        dispatch( {
            type: actions.UPDATE_NOTIFICATION_REQ,
            isFetching: true,
            isError: false,
        } );

        requestHelpers
            .authenticatedPostRequest( `/people/${data.personId}/notification/${ data.notificationId }`, data, 'PUT'  )
                .then( ( response ) => {
                    return dispatch( {
                        type: actions.UPDATE_NOTIFICATION_SUCCESS,
                        notifications: response.data,
                        isFetching: false,
                        isError: false,
                    } )
                } )

                .catch( ( error ) => {
                    return dispatch( { 
                        type: actions.UPDATE_NOTIFICATION_ERROR,
                        error: error,
                        isFecthing: false,
                        isError: true
                    } )
                } )
    }
}



module.exports = {
    actions,
    getNotifications,
    updateNotification
}


// WEBPACK FOOTER //
// src/client/actions/common/site_notifications.js